import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';

function PersonDetail({ teamMembers }) {
    const { personId } = useParams();
    const person = teamMembers.find(member => member.id === personId);

    if (!person) {
        return (
            <div className="min-h-screen flex flex-col justify-center items-center">
                <Header />
                <div className="text-center">
                    <p>Person not found!</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex flex-col md:flex-row items-center">
            <Header />
            <div className="md:w-2/3 p-4 md:py-[10%] order-1 md:order-none"> {/* changed order here */}
                <div className="flex flex-col items-center md:items-start justify-center w-full mx-auto">
                    {person.description.map((paragraph, index) => (
                        <p
                            key={index}
                            className="text-justify text-lg leading-relaxed border-b pb-3 px-6"
                        >
                            {paragraph}
                        </p>
                    ))}
                </div>
            </div>
            <div className="md:w-1/3 p-4 pt-24 md:pt-4 text-center order-0 md:order-none"> {/* changed order here */}
                <img
                    src={person.image}
                    alt={person.name}
                    className="w-full max-h-[50vh] object-contain mb-4 md:mb-0"
                />
                <h2 className="text-xl md:text-2xl font-bold pt-2">
                    {person.name == "Gerard Hooi" ? <><span>{person.name}</span><span className="text-sm">{", PBM"}</span></> : person.name}
                </h2>
                <p className="text-gray-700">{person.role}</p>
            </div>
        </div>
    );


}

export default PersonDetail;
